// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';

  window.startSwiper = (swiper_container, swiper_options, swiper_modules) => {

    swiper_modules.includes('pagination') && swiper_options.modules.push(Pagination);
    swiper_modules.includes('autoplay') && swiper_options.modules.push(Autoplay);

    
    const mySwiper = new Swiper(swiper_container , swiper_options );
 
}

window.initializeSwiper && window.initializeSwiper();

